import {
  Button,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { ClmInstanceSelection } from 'features/cluster/autoscaler/components/ClmCompatibleFamiliesPicker';

import { SetupSteps } from './SetupSteps';

import { getDocsLink } from '@cast/utils';

type Props = {
  clmInstanceSelection?: ClmInstanceSelection;
  onOpenCompatibleInstancesDrawer: () => void;
  onClose: () => void;
};

export const GuideSlide = ({
  clmInstanceSelection,
  onOpenCompatibleInstancesDrawer,
  onClose,
}: Props) => {
  return (
    <>
      <DrawerHeader />
      <DrawerBody>
        <DrawerContent>
          <Stack gap={24}>
            <Stack gap={8}>
              <Typography
                variant="L12R"
                color={tokens.theme.fg.structural.secondary}
                sx={{ textTransform: 'uppercase', letterSpacing: '1px' }}
              >
                Container live migration
              </Typography>
              <Stack gap={2}>
                <Typography variant="h5">Setup guide</Typography>
                <Typography variant="P12R" color="textSecondary">
                  A few prerequisites before CLM can move workloads. Configure
                  them once on the NodePool that CLM will manage.{' '}
                  <ExternalLink
                    link={getDocsLink('docs_container_live_migration')}
                  >
                    Documentation
                  </ExternalLink>
                </Typography>
              </Stack>
            </Stack>
            <SetupSteps
              clmInstanceSelection={clmInstanceSelection}
              onOpenCompatibleInstancesDrawer={onOpenCompatibleInstancesDrawer}
            />
          </Stack>
        </DrawerContent>
      </DrawerBody>
      <DrawerFooter>
        <Button
          variant="secondary"
          onClick={onClose}
          testId="clm-setup-guide-close-button"
        >
          Close
        </Button>
      </DrawerFooter>
    </>
  );
};
